import { useReducer, useCallback } from 'react';
import moment from 'moment';

const mapToString = date => moment(date).format('MM/DD/YYYY');

const parseDate = (startDateInput, endDateInput) => {
  const dates = [new Date(startDateInput), new Date(endDateInput)];
  return dates.reduce(
    (acc, date) => (moment(date).isValid() ? [...acc, date] : acc),
    [],
  );
};

const dateRangeReducer = (state, action) => {
  switch (action.type) {
    case 'startInputDate':
      return {
        ...state,
        startInputValue: action.payload,
        isValid: moment(action.payload) < moment(state.endInputValue),
        dates: parseDate(action.payload, state.endInputValue),
      };
    case 'endInputDate':
      return {
        ...state,
        endInputValue: action.payload,
        isValid: moment(state.startInputValue) < moment(action.payload),
        dates: parseDate(state.startInputValue, action.payload),
      };
    case 'firstPick':
      return {
        ...state,
        startInputValue: mapToString(action.payload[0]),
        dates: action.payload,
      };
    case 'secondPick':
      return {
        ...state,
        activeFilter: '',
        isValid: true,
        startInputValue: mapToString(action.payload[0]),
        endInputValue: mapToString(action.payload[1]),
        dates: action.payload,
      };
    case 'filter':
      return {
        isValid: true,
        startInputValue: action.payload[0],
        endInputValue: action.payload[1],
        dates: parseDate(action.payload[0], action.payload[1]),
        activeFilter: action.daysToFilter,
      };
    default:
      throw new Error();
  }
};

const useDateInput = ({ initialDates = [] }) => {
  const [dateRange, dispatch] = useReducer(dateRangeReducer, {
    startInputValue: mapToString(initialDates[0]),
    endInputValue: mapToString(initialDates[1]),
    dates: initialDates,
    isValid: false,
    activeFilter: '',
  });

  const onInputChange = useCallback(e => {
    const dateInputValue = e.target.value;
    const datePosition = e.target.id.toString();
    dispatch({ type: datePosition, payload: dateInputValue });
  }, []);

  const onDateChange = useCallback(
    dates =>
      dates.length <= 1
        ? dispatch({ type: 'firstPick', payload: dates })
        : dispatch({ type: 'secondPick', payload: dates }),
    [],
  );

  const onFilterChange = useCallback(daysToFilter => {
    const todayDate = moment().format('MM/DD/YYYY');
    const startDate = daysToFilter
      ? moment(todayDate)
          .subtract(daysToFilter, 'd')
          .format('MM/DD/YYYY')
      : null;

    dispatch({ type: 'filter', payload: [startDate, todayDate], daysToFilter });
  }, []);

  return {
    onDateChange,
    onInputChange,
    onFilterChange,
    ...dateRange,
  };
};

export default useDateInput;
